<div class="main-container">

  <div class="page-header">
    <div class="title">
      <span class="title-text">Manage Establishments</span>
      <p class="small-title">Branches (mandirs) and their location details.</p>
    </div>
    <div class="header-actions">
      <button type="button" class="ac-primary-btn" [disabled]="isLoading" (click)="addEstablishment()">Add Establishment</button>
    </div>
  </div>

  <div class="table-container ac-table-region" role="region" aria-label="Establishments" tabindex="0">
    <table class="table ac-responsive-table">
      <thead class="table-head">
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Code</th>
          <th scope="col">Name</th>
          <th scope="col">State</th>
          <th scope="col">District</th>
          <th scope="col">Pincode</th>
          <th scope="col">Status</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(est of establishments; track est.establishmentId){
        <tr>
          <td data-label="Id">{{ est.establishmentId }}</td>
          <td data-label="Code">{{ est.code }}</td>
          <td data-label="Name">{{ est.name }}</td>
          <td data-label="State">{{ est.state || '-' }}</td>
          <td data-label="District">{{ est.district || '-' }}</td>
          <td data-label="Pincode">{{ est.pincode || '-' }}</td>
          <td data-label="Status">{{ est.status === 1 ? 'Active' : 'Inactive' }}</td>
          <td class="ac-actions-column actions-cell" data-label="Actions">
            <button type="button" class="ac-secondary-small-btn" (click)="editEstablishment(est)">Edit</button>
          </td>
        </tr>
        }
        @if(!isLoading && establishments.length === 0){
        <tr>
          <td colspan="8" class="empty-row">No branches found.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
